"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.POW = void 0;
exports.POW = {
    alias: 'POTENCIA',
    description: 'Calcula o valor da base elevada ao expoente especificado',
    arg_names: ['base', 'expoente'],
    args_description: [
        'Número que será usado como base',
        'Número que será usado como expoente',
    ],
};
